export default "__VITE_ASSET__CLU1QZGn__"